import NavBreadcrum from "../../components/NavBreadcrum";
import MenuButtons from "../../components/MenuButtons";
import navs from "./navs";
import { useTranslation } from "react-i18next";

const MainAdmin = () => {
    const [t] = useTranslation("routes")

    const bread = [
        { name: t("labels.administration"), current: true }
    ]


    return (
        <>
            <NavBreadcrum navs={navs} bread={bread} />
            <MenuButtons navs={navs} />
        </>
    )
}

export default MainAdmin